import { createBrowserRouter, Navigate } from 'react-router-dom';
import { Layout, RequireAuth } from './components/Layout';
import { Login } from './pages/Login';
import { Signup } from './pages/Signup';
import { Dashboard } from './pages/Dashboard';
import { GamePlay } from './pages/GamePlay';
import { Settings } from './pages/Settings';
import { InstructorClass } from './pages/InstructorClass';

export const router: ReturnType<typeof createBrowserRouter> = createBrowserRouter([
  { path: '/login', element: <Login /> },
  { path: '/signup', element: <Signup /> },
  {
    element: (
      <RequireAuth>
        <Layout />
      </RequireAuth>
    ),
    children: [
      { path: '/', element: <Navigate to="/dashboard" replace /> },
      { path: '/dashboard', element: <Dashboard /> },
      { path: '/classes/:id', element: <InstructorClass /> },
      { path: '/play/:gameId', element: <GamePlay /> },
      { path: '/settings', element: <Settings /> },
    ],
  },
  { path: '*', element: <Navigate to="/dashboard" replace /> },
]);
